import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import rawBankTransactionsApi from '@/features/dashboard/rawBankTransactions/api/rawBankTransactionsApi.ts';
import { RawTransactionDto } from '@/features/dashboard/rawBankTransactions/types/RawTransactionDto.ts';
import { invalidateFinanceRelatedQueries } from '@/utils/invalidateFinanceQueries.ts';

const useRevertTransaction = () => {
  const queryClient = useQueryClient();

  return useMutation<RawTransactionDto, Error, string>({
    mutationFn: (id) => rawBankTransactionsApi.revert(id),
    onSuccess: () => {
      toast.success('Przelew wrócił do oczekujących');
      invalidateFinanceRelatedQueries(queryClient);
    },
    onError: (error: Error) => {
      toast.error('Nie udało się przywrócić przelewu', {
        description: error.message,
      });
    },
  });
};

export default useRevertTransaction;
